import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.023 9.762q-.281.901-.887 1.803-.93 1.413-1.854 1.413-.353 0-1.01-.23-.62-.231-1.088-.231-.44 0-1.024.238-.584.245-.952.245-1.096 0-2.17-1.868-1.06-1.882-1.06-3.627 0-1.644.814-2.697Q3.6 3.769 4.84 3.769q.52 0 1.277.217.75.216.995.216.324 0 1.031-.245.736-.245 1.248-.245.858 0 1.536.468.375.26.75.721-.57.484-.822.851-.47.678-.47 1.493 0 .894.498 1.608t1.14.909M9.31 1.302q0 .44-.209.982-.216.54-.67.995-.39.39-.78.52-.266.078-.75.122.022-1.075.563-1.854Q8 1.296 9.268 1q.007.022.018.08.01.057.018.079 0 .028.004.072.004.043.004.072z" }, null, -1)
  ]))]))
}
export default { render: render }